import { Box, FormLabel } from '@chakra-ui/react'
import { ContractDocType } from 'BrokerTsLib/src/enums'
import { useEffect } from 'react'

import { useGetDocuments } from '../../hooks/useDocuments'
import { DownloadButton } from '../DownloadButton'
import { Loading } from '../../components/Loading'
import { useAuth } from '../../context/AuthContext'
import { InsuranceUpload } from './InsuranceUpload'

export const InsuranceDownloads = ({
  offerId,
  title = 'Dokumenty a informace k pojištění',
}: {
  offerId: number
  title?: string
}) => {
  const auth = useAuth()
  const { data, refetch, isLoading } = useGetDocuments(offerId, { enabled: false })
  const allDocuments = data?.data ?? []

  useEffect(() => {
    refetch()
  }, [refetch])

  const mergedDoc = allDocuments?.find((x) => x.type === ContractDocType.MergedDocuments)
  const nonLegalDocs =
    allDocuments?.filter((x) => !x.isLegalType && x.type !== ContractDocType.MergedDocuments) ?? []
  const legalDocs =
    allDocuments?.filter((x) => x.isLegalType && x.type !== ContractDocType.MergedDocuments) ?? []

  return (
    <Box sx={{ display: 'grid', gap: 8, placeItems: 'start' }}>
      {isLoading && <Loading />}

      {!isLoading && (
        <>
          <Box sx={{ display: 'grid', gap: 4, placeItems: 'start' }}>
            <FormLabel>{title}</FormLabel>

            {mergedDoc && (
              <DownloadButton isDownloadAll as="a" href={mergedDoc.url} target="_blank">
                Stáhnout kompletní dokumentaci
              </DownloadButton>
            )}

            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: { base: '1fr', md: '1fr 1fr' },
                placeContent: 'start',
                placeItems: 'start',
                gap: 2,
              }}
            >
              {nonLegalDocs.map((x) => (
                <DownloadButton key={x.url} as="a" href={x.url} target="_blank">
                  {x.description}
                </DownloadButton>
              ))}
            </Box>
          </Box>

          {legalDocs.length > 0 && (
            <Box sx={{ display: 'grid', gap: 4, placeItems: 'start' }}>
              <FormLabel>Právní dokumenty k pojištění</FormLabel>

              {legalDocs.map((x) => (
                <DownloadButton key={x.url} as="a" href={x.url} target="_blank">
                  {x.description}
                </DownloadButton>
              ))}
            </Box>
          )}

          {auth?.user?.allowUploadInsuranceDocuments && (
            <InsuranceUpload
              offerId={offerId}
              existingDocuments={allDocuments}
              onUpload={refetch}
            />
          )}
        </>
      )}
    </Box>
  )
}
